import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  AdditionalAdviceScreenshotData,
  AdditionalAkaAdviceScreenshotData,
  AdvicePDFError,
  AdvicePDFResponse,
  AdvicePDFStartData,
  AdvicePDFState,
  AkaAdvicePDFStartData,
} from "./interfaces";

const initialState: AdvicePDFState = {
  request: undefined,
  response: {
    current: null,
    isLoading: false,
    error: null,
  },
};

const advicePDFSlice = createSlice({
  name: "advicePDF",
  initialState,
  reducers: {
    resetAdvicePDF: (state) => {
      state.request = undefined;
      state.response.current = null;
      state.response.isLoading = false;
      state.response.error = null;
    },

    akaAdvicePDFStart: (
      state,
      _action: PayloadAction<AkaAdvicePDFStartData>,
    ) => {
      state.response.isLoading = true;
    },

    advicePDFStart: (state, _action: PayloadAction<AdvicePDFStartData>) => {
      state.response.isLoading = true;
    },

    advicePDFSucceeded: (state, action: PayloadAction<AdvicePDFResponse>) => {
      state.response.current = {
        ...state.response.current,
        ...action.payload,
      };
      state.response.isLoading = false;
    },

    operationFailed: (state, action: PayloadAction<AdvicePDFError>) => {
      state.response.error = action.payload;
      state.response.isLoading = false;
    },

    updateAdvicePDFRequestState: (
      state,
      action: PayloadAction<
        AdditionalAdviceScreenshotData | AdditionalAkaAdviceScreenshotData
      >,
    ) => {
      state.request = action.payload;
    },
  },
});

export const {
  akaAdvicePDFStart,
  advicePDFStart,
  advicePDFSucceeded,
  operationFailed,
  resetAdvicePDF,
  updateAdvicePDFRequestState,
} = advicePDFSlice.actions;
export const advicePDF = advicePDFSlice.reducer;
